module.exports = __webpack_public_path__ + "img/spitter-run-6.6212cad7.png";